import { useNavigate } from 'react-router-dom';
import { FC, useCallback, useEffect } from 'react';
import { TocContainer } from '@higo/ui';

// used to isolate re-renders from useNavigate
const initialActiveSectionId = 'examinationContext';
export const ExaminationPageTocContainer: FC = ({ children }) => {
  const navigate = useNavigate();

  const setActiveSection = useCallback(
    (id: string) => navigate(`#${id}`),
    [navigate],
  );

  useEffect(() => {
    setActiveSection(initialActiveSectionId);
  }, [setActiveSection]);

  return (
    <TocContainer
      onChange={setActiveSection}
      initialTrigger={250}
      initialThreshold={30}
    >
      {children}
    </TocContainer>
  );
};
